import SharedThirdNavBar, {
  NavigationItem
} from '@src/components/navigationBar/third/SharedThirdNavBar'
import { FeatureFlagType } from '@src/constants/featureFlag'
import { ROUTE } from '@src/constants/route'
import featureAllowed from '@src/util/apeiron/featureAllowed'
import { FC, useMemo } from 'react'

export const BAR_HEIGHT = 60

const InventoryPlanetThirdNavBar: FC<Props> = (props: Props) => {
  const { index = 0, isSelection = false, onChange } = props

  const navigationItems: NavigationItem[] = useMemo(
    () => [
      {
        icon: '',
        route: ROUTE.INVENTORY_PLANET_LIST,
        translationKey: 'sub_bar.planet.nft'
      },
      ...(isSelection
        ? [
            {
              icon: '',
              route: ROUTE.INVENTORY_PLANET_SEED_LIST,
              translationKey: 'sub_bar.planet.seed_planet'
            }
          ]
        : []),
      ...(featureAllowed(FeatureFlagType.ShowPlanetHistory)
        ? [
            {
              icon: '',
              route: ROUTE.INVENTORY_PLANET_HISTORY,
              translationKey: 'common.history'
            }
          ]
        : [])
    ],
    [isSelection]
  )

  return (
    <SharedThirdNavBar
      height={BAR_HEIGHT}
      index={index}
      navigationItems={navigationItems}
      onChange={onChange}
    />
  )
}

type Props = {
  index: number
  isSelection?: boolean
  onChange?: (index: number) => void
}

export default InventoryPlanetThirdNavBar
